import consoleLogErrors from './consoleLogErrors';
import auth from './auth';
import projectList from './projectList';
import projectView from './projectView';
import deviationView from './deviationView';
import deviationList from './deviationList';
import productTypeView from './productTypeView';
import productTypeList from './productTypeList';
import roomTypeView from './roomTypeView';
import roomTypeList from './roomTypeList';
import userView from './userView';
import userList from './userList';
import notifications from './notifications';
import workerTypeView from './workerTypeView';
import workerTypeList from './workerTypeList';
import files from './files';
import productView from './productView';
import productList from './productList';
import apartmentView from './apartmentView';
import customerView from './customerView';
import customerOrderView from './customerOrderView';
import orderList from './orderList';
import orderView from './orderView';
import customRowView from './customRowView';
import purchaseOrderList from './purchaseOrderList';
import purchaseOrderView from './purchaseOrderView';
import apartmentConfigView from './apartmentConfigView';
import configTemplateList from './configTemplateList';
import configTemplateView from './configTemplateView';
import supplierView from './supplierView';
import supplierList from './supplierList';
import actionConfirmation from './actionConfirmation';
import activation from './activation';
import exportsView from './exportsView.js';
import salesView from './salesView.js';
import purchaseReportView from './purchaseReportView.js';
import siteManagerReportView from './siteManagerReportView.js';
import roomTemplateList from './roomTemplateList.js';
import roomTemplateView from './roomTemplateView.js';

export {
  consoleLogErrors,
  auth,
  projectList,
  projectView,
  deviationView,
  deviationList,
  productTypeView,
  productTypeList,
  roomTypeView,
  roomTypeList,
  userView,
  userList,
  notifications,
  workerTypeView,
  workerTypeList,
  files,
  productView,
  productList,
  apartmentView,
  customerView,
  customerOrderView,
  orderList,
  orderView,
  customRowView,
  purchaseOrderList,
  purchaseOrderView,
  apartmentConfigView,
  configTemplateList,
  configTemplateView,
  supplierView,
  supplierList,
  actionConfirmation,
  activation,
  exportsView,
  salesView,
  purchaseReportView,
  siteManagerReportView,
  roomTemplateList,
  roomTemplateView,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js